import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Eyebrow } from './Eyebrow';
export function TestimonialWall() {
  const [featured, ...supporting] = testimonials;
  return <section aria-labelledby="reviews-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-240" data-mp="3isu4zq1cbng7">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-241" data-mp="3mu5n7ahvx6ed">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-242" data-mp="38vfpptr5l4ph">
          <div data-id="element-243" data-mp="38xseaprf2dbi">
            <Eyebrow data-id="element-244" data-mp="3du94rqm393rr">Trusted by jazz educators worldwide</Eyebrow>
            <h2 id="reviews-heading" className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-245" data-mp="3dsftfy0j5vdf">
              What educators are saying
            </h2>
          </div>
          <p className="flex items-center gap-2 text-sm text-ink-muted" data-id="element-246" data-mp="y2uzrobojsha">
            <StarIcon className="h-4 w-4 fill-brass text-brass" aria-hidden="true" data-id="element-247" data-mp="y1jxjsxvussa" />
            <span className="font-semibold text-ink-soft" data-id="element-248" data-mp="122vnjzko5g10">4.9/5</span> &middot; 2,500+ educators
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]" data-id="element-249" data-mp="1rnyt0tq0iosp">
          <figure className="flex flex-col border border-brass/40 bg-paper p-6 sm:p-10" data-id="element-250" data-mp="1rm4ga2owa2zp">
            <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-251" data-mp="26ey1m4quldca">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-brass text-brass" aria-hidden="true" data-id="element-252" data-mp="1dno1rpksj870" data-mpi={index} />)}
            </div>
            <blockquote className="mt-6 font-display text-2xl leading-snug text-ink sm:mt-7 sm:text-[2.25rem]" data-id="element-253" data-mp="18qnu5a8alxds">
              &ldquo;{featured.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-4 pt-9" data-id="element-254" data-mp="1im91lnw4rpux">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brass-wash text-xs font-semibold tracking-wider text-brass-dark" data-id="element-255" data-mp="2z10wc7gr197e">
                {featured.initials}
              </span>
              <span className="text-sm text-ink-muted" data-id="element-256" data-mp="314m59rv43yos">
                <span className="block font-semibold text-ink" data-id="element-257" data-mp="364qmxl7razgl">{featured.name}</span>
                {featured.role} &middot; {featured.location}
              </span>
            </figcaption>
          </figure>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-258" data-mp="3g2mw47h4vkc2">
            {supporting.map(item => <figure key={item.name} className="flex flex-col border border-paper-300 bg-paper p-7" data-id="element-259" data-mp="2ifo62fky5an5">
                <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-260" data-mp="2neimxbzcsp4m">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-3 w-3 fill-brass text-brass" aria-hidden="true" data-id="element-261" data-mp="2x4kdcaf6ijmp" data-mpi={index} />)}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-ink-soft" data-id="element-262" data-mp="24mge2msyed4x">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5 text-xs text-ink-muted" data-id="element-263" data-mp="hrb8khp7ertb">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-paper-200 text-[10px] font-semibold text-brass-dark" data-id="element-264" data-mp="crouy75gr9jz">
                    {item.initials}
                  </span>
                  <span data-id="element-265" data-mp="2u0wp78nfjx2">
                    <span className="font-semibold text-ink-soft" data-id="element-266" data-mp="2vc1999x4vp8">{item.name}</span> &middot;{' '}
                    {item.role} &middot; {item.location}
                  </span>
                </figcaption>
              </figure>)}
          </div>
        </div>
      </div>
    </section>;
}